/**
 * ReportTypeTile — card de um tipo de relatório LGPD (B5_ReportTile no mockup).
 *
 * Tipos forenses (forensicLevel) ficam BLOQUEADOS quando o descriptor chega
 * com `availableToCaller=false` (caller sem `audit-events-read-sensitive`,
 * decisão (b) Gap 2 / pattern D-B). Bloqueado = não selecionável + cadeado.
 */

import type { LgpdReportTypeDescriptor } from './types';

export function ReportTypeTile({
  report,
  selected,
  onSelect,
}: {
  report: LgpdReportTypeDescriptor;
  selected: boolean;
  onSelect: (id: LgpdReportTypeDescriptor['id']) => void;
}): JSX.Element {
  const locked = report.forensicLevel && !report.availableToCaller;

  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      aria-label={report.label}
      disabled={locked}
      title={
        locked
          ? 'Relatório forense — restrito a perfis com acesso à auditoria sensível'
          : report.hint
      }
      className={
        'rep-tile' + (selected ? ' rep-tile--selected' : '') + (locked ? ' rep-tile--locked' : '')
      }
      onClick={() => {
        if (!locked) onSelect(report.id);
      }}
    >
      <span className="rep-tile__title">
        {report.label}
        {locked && (
          <span className="rep-tile__lock" aria-hidden="true">
            🔒
          </span>
        )}
      </span>
      <span className="rep-tile__hint">{report.hint}</span>
      {report.forensicLevel && <span className="rep-tile__badge">nível forense</span>}
    </button>
  );
}
